module.exports = __webpack_public_path__ + "img/center back length to waist seam.4f2982b9.png";